import { Injectable } from '@angular/core';
import { MiraieService } from './miraie.service';
import { AuthService } from '../Services/auth.service';


@Injectable({
  providedIn: 'root'
})
export class MatchingService {

  //条件保持用
  br_flg = false;
  mltab_conditions = "1";

  constructor(
    public authService: AuthService,
    private http: MiraieService,
  ) { }

  //セッションからid取得
  user_id: number;
  //user_id2: number;
  getUserId() {
    this.user_id = this.authService.getUserCode();
    //this.user_id2 = this.authService.getUserCode();
  }

  //予約一覧
  getRequestList() {
    var url = 'webrequest/list';

    return this.http.get(url);
  }

  //予約詳細
  getWebRequest(request_code) {
    var url = 'webrequest/get';
    let param = { request_code };

    return this.http.post(url, param);
  }

  //予約確定
  matchingRequest(request) {
    var url = 'webrequest/match';

    return this.http.post(url, request);
  }

  //未割当顧客一覧
  matchingList(conditions) {
    var url = "matching-list";
    let param = { conditions };

    this.getUserId();

    return this.http.post(url, param);
  }

  //未割当顧客詳細
  matchingDetail(customer_code) {
    var url = "matching-detail";
    let param = { customer_code };

    return this.http.post(url, param);
  }
  //割当ユーザ一覧画面
  matchingUserList(datail) {
    var url = "matching-user-list";
    let param = { datail };

    return this.http.post(url, param);
  }
  //マッチング
  matchingInput(data) {
    var url = "matching-input";
    this.getUserId();
    var user_id = this.user_id;
    let param = { data, user_id };

    return this.http.post(url, param);
  }
  //キャンセル
  matchingCancel(data) {
    var url = "matching-cancel";
    this.getUserId();
    var user_id = this.user_id;
    let param = { data, user_id };

    return this.http.post(url, param);
  }
  //マッチング後
  matchingResult(customer_code) {
    var url = "matching-result";
    this.getUserId();
    var user_id = this.user_id;
    let param = { customer_code, user_id };

    return this.http.post(url, param);
  }

}
